import { render, staticRenderFns } from "./TxPresenterDrawer.vue?vue&type=template&id=b1600f20&scoped=true"
import script from "./TxPresenterDrawer.vue?vue&type=script&lang=js"
export * from "./TxPresenterDrawer.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterDrawer.vue?vue&type=style&index=0&id=b1600f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1600f20",
  null
  
)

export default component.exports